// extracted by css-extract-rspack-plugin
export default {"root":"src-components-DropdownRow-DropdownRow-module__root-ZD6va6","dropdown-indicator":"src-components-DropdownRow-DropdownRow-module__dropdown-indicator-anqbI5","dropdownIndicator":"src-components-DropdownRow-DropdownRow-module__dropdown-indicator-anqbI5","row-container":"src-components-DropdownRow-DropdownRow-module__row-container-vR9D3o","rowContainer":"src-components-DropdownRow-DropdownRow-module__row-container-vR9D3o","content-container":"src-components-DropdownRow-DropdownRow-module__content-container-Ygu5DQ","contentContainer":"src-components-DropdownRow-DropdownRow-module__content-container-Ygu5DQ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-DropdownRow-DropdownRow-module__root-ZD6va6\",\"dropdown-indicator\":\"src-components-DropdownRow-DropdownRow-module__dropdown-indicator-anqbI5\",\"dropdownIndicator\":\"src-components-DropdownRow-DropdownRow-module__dropdown-indicator-anqbI5\",\"row-container\":\"src-components-DropdownRow-DropdownRow-module__row-container-vR9D3o\",\"rowContainer\":\"src-components-DropdownRow-DropdownRow-module__row-container-vR9D3o\",\"content-container\":\"src-components-DropdownRow-DropdownRow-module__content-container-Ygu5DQ\",\"contentContainer\":\"src-components-DropdownRow-DropdownRow-module__content-container-Ygu5DQ\"}";
        // 1772473573015
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  